// src/components/Services.jsx

import React from 'react';

const ExitStrategy = () => {
  return (
      <div className="flex flex-col items-center justify-center h-screen bg-white">
        <h2 className="text-4xl font-bold text-black mb-5">
          Exit Strategy And<span className="text-[#680099] ml-2 font-bold">Investor Returns</span>
        </h2>
        <h2 className="text-4xl font-bold text-black mb-5">
          Revealing<span className="text-[#680099] ml-2 font-bold">Soon!</span>
        </h2>


        {/*/!* Container for the two boxes *!/*/}
        {/*<div style={boxesContainerStyle}>*/}
        {/*  /!* Left box *!/*/}
        {/*  <div style={leftBoxStyle}>*/}
        {/*    <div style={boxHeadingStyle}>Exit Option</div>*/}
        {/*    <p style={boxContentStyle}> Acquisitions</p>*/}
        {/*    <p style={leftboxContentStyle}> IPO</p>*/}
        {/*    <p style={leftboxContentStyle}> Share Buyback</p>*/}

        {/*  </div>*/}

        {/*  <div style={midBoxStyle}>*/}
        {/*    <div style={boxHeadingStyle}>Timeline</div>*/}
        {/*    <p style={boxContentStyle}> 3-5 Years</p>*/}
        {/*    <p style={leftboxContentStyle}> 5-7 Years</p>*/}
        {/*    <p style={leftboxContentStyle}> 3-5 Years</p>*/}
        {/*  </div>*/}

        {/*  <div style={rightBoxStyle}>*/}
        {/*    <div style={boxHeadingStyle}>Details</div>*/}
        {/*    <p style={boxContentStyle}>Targeted by Larger Travel or FinTech Companies for Scalable B2B And B2C*/}
        {/*      Solutions. </p>*/}
        {/*    <p style={rightboxContentStyle}>Long Term Goals, Providing Inevstor Liquidity And Brand Positioning.</p>*/}
        {/*    <p style={rightboxContentStyle}>Profits Used For Share Buybacks, Offering Premium Exits for Early*/}
        {/*      Investors.</p>*/}

        {/*  </div>*/}
        {/*</div>*/}

        {/*<br/>*/}

        {/*<p style={{fontSize: '19px'}}><strong>Investor Returns</strong>: 3-Year Projected Dividend Returns (30% payout)*/}
        {/*</p>*/}
        {/*<div style={boxesContainerStyle}>*/}
        {/*  /!* Left box *!/*/}
        {/*  <div style={leftBoxStyle2}>*/}
        {/*    <div style={boxHeadingStyle}>Year</div>*/}
        {/*    <p style={boxContentStyle}> 1 </p>*/}
        {/*    <p style={leftboxContentStyle}> 2 </p>*/}
        {/*    <p style={leftboxContentStyle}> 3 </p>*/}

        {/*  </div>*/}

        {/*  <div style={leftBoxStyle1}>*/}
        {/*    <div style={boxHeadingStyle}>Net Profit</div>*/}
        {/*    <p style={boxContentStyle}> ₹65 Lakhs</p>*/}
        {/*    <p style={leftboxContentStyle}> ₹1.04 Crore</p>*/}
        {/*    <p style={leftboxContentStyle}> ₹1.72 Crore</p>*/}

        {/*  </div>*/}

        {/*  <div style={midBoxStyle2}>*/}
        {/*    <div style={boxHeadingStyle}>Dividend Pool</div>*/}
        {/*    <p style={boxContentStyle}> ₹19.5 Lakhs</p>*/}
        {/*    <p style={leftboxContentStyle}> ₹31.2 Lakhs</p>*/}
        {/*    <p style={leftboxContentStyle}> ₹51.6 Lakhs</p>*/}

        {/*  </div>*/}

        {/*  <div style={rightBoxStyle2}>*/}
        {/*    <div style={boxHeadingStyle}>Investor's Dividend (5.5%)</div>*/}
        {/*    <p style={boxContentStyle}> ₹1.07 Lakhs</p>*/}
        {/*    <p style={leftboxContentStyle}> ₹1.72 Lakhs</p>*/}
        {/*    <p style={leftboxContentStyle}> ₹2.84 Lakhs</p>*/}

        {/*  </div>*/}
        {/*</div>*/}


      </div>
  );
};


const boxesContainerStyle = {
  display: 'flex',  // Align items side by side
  gap: '20px',  // Space between the boxes
  marginTop: '19px',  // Optional: space between heading and boxes

};

const leftBoxStyle = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '25%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',

};

const leftBoxStyle2 = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '10%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',

};

const leftBoxStyle1 = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '30%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',

};

const midBoxStyle = {
    flex: 1,  // Takes up available space, but narrower due to specific width
    maxWidth: '15%',  // Adjust width to make it narrower
    backgroundColor: '#fbf4ff',  // Background color for the box
    borderRadius: '30px',
    padding: '0px',

    
  };

  
const midBoxStyle2 = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '30%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',

  
};

const rightBoxStyle = {
  flex: 1,  // Takes up available space
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
  maxWidth: '60%',  // Adjust width to make it narrower

};

const rightBoxStyle2 = {
  flex: 1,  // Takes up available space
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
  maxWidth: '30%',  // Adjust width to make it narrower

};
const boxHeadingStyle = {
  backgroundColor: '#321e5d',  // Background color for the heading
  color: 'white',
  padding: '10px',
  borderRadius: '30px 30px 0px 0px',   
  fontSize: '18px',
  fontWeight: 'bold',  
  textAlign: 'center',

  
};

const boxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px',
  marginBottom:'25px'
};


const leftboxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px',
  marginTop: '55px'
};

const rightboxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px',
  marginBottom: '50px',

};


export default ExitStrategy;
